import { cn } from "@/lib/utils";

export function chatSendButtonClassName(canSubmit: boolean): string {
  return cn(
    "rounded-xl p-3 transition-all",
    canSubmit
      ? "bg-primary text-white shadow-[var(--primary-shadow)] hover:bg-primary/90 dark:bg-gradient-to-r dark:from-blue-600 dark:to-blue-500 dark:shadow-lg dark:shadow-blue-500/25 dark:hover:from-blue-500 dark:hover:to-blue-400"
      : "cursor-not-allowed bg-[var(--surface-sunken)] text-[#576274] dark:bg-white/5 dark:text-gray-500",
  );
}

export function chatSecondaryActionClassName(disabled = false): string {
  return cn(
    "inline-flex shrink-0 items-center gap-1.5 rounded-lg border px-3 py-2 text-xs font-medium transition-colors border-[rgba(15,23,42,0.09)]",
    disabled
      ? "cursor-not-allowed bg-[var(--surface-sunken)] text-[#576274] dark:bg-white/5 dark:text-gray-500"
      : "bg-white text-[#576274] shadow-[var(--shadow-card)] hover:bg-[var(--lm-hover)] hover:text-[#101828] dark:border-white/5 dark:bg-white/5 dark:text-gray-400 dark:shadow-none dark:hover:bg-white/10",
  );
}
